import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/license/seats/license.seats.grant.mutation.gql"
import type {
  LicenseSeatGrantMutation,
  LicenseSeatGrantMutationVariables,
} from "@/v2-backoffice-client/license/seats/__types__/license.seats.grant.mutation"

type Options = MutationHookOptions<
  LicenseSeatGrantMutation,
  LicenseSeatGrantMutationVariables
>

export function useLicenseSeatGrantMutation(options?: Options) {
  return useMutation<
    LicenseSeatGrantMutation,
    LicenseSeatGrantMutationVariables
  >(mutation, options)
}
